// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bulma/css/bulma.css'
import 'bulma-checkradio/dist/bulma-checkradio.min.css'
import 'bulma-switch/dist/css/bulma-switch.min.css'
import '@mdi/font/scss/materialdesignicons.scss'
import 'vue-touch-ripple/dist/vue-touch-ripple.css'
// For Analytics
import 'autotrack/lib/plugins/event-tracker'
import 'autotrack/lib/plugins/outbound-link-tracker'
import 'autotrack/lib/plugins/url-change-tracker'

import { LanguagePlugin } from './services/LanguageHandler'
import { auth, refreshData, axiosDriver, fetchData, logoutData } from './services/AuthHandler'
import { createQuery } from './services/Utils'

import { store } from './store'
import { sync } from 'vuex-router-sync'
import Vue from 'vue'
import App from './App'
import Router from 'vue-router'
import Meta from 'vue-meta'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import routes from './router'
import EventBus from './plugins/EventBus'
import RPC from './plugins/RPC'
import AsyncComputed from 'vue-async-computed'

window.ga('require', 'eventTracker')
window.ga('require', 'outboundLinkTracker')
window.ga('require', 'urlChangeTracker')
window.ga('send', 'pageview')

const env = require('./../.environment')
let router = new Router(routes)
router.beforeEach(async (to, from, next) => {
  let lastChar = to.path[to.path.length - 1]
  if (lastChar === '/' && to.name !== 'Home') next(`${to.path.slice(0, -1)}?${createQuery(to.query)}`)
  next()
})

export { router }

const VueCookie = require('vue-cookie')
Vue.router = router
Vue.use(LanguagePlugin)
Vue.use(Router)
Vue.use(Meta)
Vue.use(EventBus)
Vue.use(VueAxios, axios)
Vue.use(VueAuth, {
  auth: auth,
  tokenDefaultName: 'jwt_auth_token',
  fetchData: fetchData,
  refreshData: refreshData,
  logoutData: logoutData,
  http: axiosDriver,
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js')
})
Vue.use(RPC, env.RPC_ENDPOINT)
Vue.use(VueCookie)
Vue.use(AsyncComputed)

sync(store, router)

Vue.config.productionTip = false

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js